import { motion } from "framer-motion";
import { ChefHat } from "lucide-react";

const CUISINES = [
  {
    name: "Caribbean",
    note: "Island spices, slow-braised meats and vibrant, sun-soaked flavours.",
    img: "https://images.pexels.com/photos/23644633/pexels-photo-23644633.jpeg",
    alt: "Caribbean-inspired gourmet plated dish",
  },
  {
    name: "Asian",
    note: "Delicate balance — fresh, aromatic plates from across the East.",
    img: "https://images.pexels.com/photos/24289165/pexels-photo-24289165.jpeg",
    alt: "Elegantly plated Asian shrimp appetizer",
  },
  {
    name: "American",
    note: "Elevated classics — refined comfort with a steakhouse soul.",
    img: "https://images.unsplash.com/photo-1663530761401-15eefb544889",
    alt: "Chef finishing a plated American steak dish",
  },
];

const reveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function Catering() {
  return (
    <section id="catering" data-testid="catering-section" className="py-28 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-20">
          <div className="lg:col-span-7">
            <motion.p {...reveal} transition={{ duration: 0.7 }} className="eyebrow flex items-center gap-3">
              <ChefHat className="w-4 h-4 text-[#D8A7A1]" /> The Private Chef Experience
            </motion.p>
            <motion.h2
              {...reveal}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="mt-6 font-serif font-light text-4xl sm:text-5xl leading-tight text-[#2A2423]"
            >
              Three cuisines. One chef. <em className="text-[#D8A7A1]">Zero compromise.</em>
            </motion.h2>
          </div>
          <motion.p
            {...reveal}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="lg:col-span-5 text-base leading-relaxed text-muted-foreground"
          >
            Our private chef curates bespoke menus spanning Caribbean, Asian and American cuisine — designed around your
            event, your guests and your tastes. Every plate arrives as considered as the decor surrounding it.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {CUISINES.map((c, i) => (
            <motion.article
              key={c.name}
              {...reveal}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className={`group ${i === 1 ? "md:mt-16" : ""}`}
              data-testid={`cuisine-card-${c.name.toLowerCase()}`}
            >
              <div className="overflow-hidden rounded-t-full border border-[#E5D3B3] aspect-[3/4]">
                <img
                  src={c.img}
                  alt={c.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="pt-6 border-b border-[#E5D3B3] pb-6">
                <div className="flex items-baseline justify-between">
                  <h3 className="font-serif text-2xl text-[#2A2423]">{c.name}</h3>
                  <span className="font-serif italic text-[#D8A7A1] text-lg">0{i + 1}</span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{c.note}</p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
